import * as React from 'react'

import GradientText from 'components/gradient-text/GradientText'
import SectionWrapper from 'components/section-wrapper'
import {faqData} from 'content/footer'
import {motion, AnimatePresence} from 'motion/react'
import {FaChevronDown, FaChevronUp} from 'react-icons/fa'

import classes from './styles.module.css'

export default function FAQS() {
  const [expanded, setExpanded] = React.useState<false | number>(false)
  return (
    <SectionWrapper bgColor="transparent">
      <GradientText text={faqData.topTitle} />
      <h2 className="header2">{faqData.title}</h2>
      <div className={classes.animationControl}>
        {faqData.faqs.map((faq, i) => (
          <div className={classes.singleQuestion} key={i}>
            <motion.header initial={false} onClick={() => setExpanded(i === expanded ? false : i)}>
              <div
                className={classes.questionSection}
                style={{marginBottom: i === expanded ? '20px' : 0}}
              >
                {faq.question}
                {i === expanded ? <FaChevronUp color="white" /> : <FaChevronDown color="white" />}
              </div>
            </motion.header>
            <AnimatePresence initial={false}>
              {i === expanded && (
                <motion.section
                  key="content"
                  initial="collapsed"
                  animate="open"
                  exit="collapsed"
                  variants={{
                    open: {opacity: 1, height: 'auto'},
                    collapsed: {opacity: 0, height: 0},
                  }}
                  transition={{duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98]}}
                >
                  <div className={classes.answer}>{faq.ans}</div>
                </motion.section>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </SectionWrapper>
  )
}
